import {CityResponseType, ICity, ITerritory} from "@/entity/territory/territory.types";

export default class Territory implements ITerritory{
    city: CityResponseType;
    constructor(data: CityResponseType) {
        // for (let i = 0; i < data.data.length; i++) {
        //     this.city.push(data.data[i]);
        // }
        this.city = data
    }
}